import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup, {
  toggleButtonGroupClasses,
} from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import ListIcon from "@mui/icons-material/List";
import ViewArrayIcon from "@mui/icons-material/ViewArray";
import CheckIcon from "@mui/icons-material/Check";
import { useLanguage } from "./Language";
import Stack from "@mui/material/Stack";

type viewType = "listView" | "flowView";

interface ResultsViewToggleProps {
  value?: viewType;
  onChange?: (event: React.MouseEvent<HTMLElement>, newValue: viewType) => void;
}

// https://m3.material.io/components/segmented-buttons/accessibility
// use an outline with at least 3:1 contrast with the surface
export const HigherContrastToggleButtonGroup = styled(ToggleButtonGroup)(
  () => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      borderColor: "rgba(0, 0, 0, 0.42)",
    },
  })
);

export const ResultsViewToggle = (props: ResultsViewToggleProps) => {
  const [value, setValue] = useState<viewType>(props.value || "listView");

  const { translate } = useLanguage();

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: viewType | null
  ) => {
    // don't allow deselection
    if (newValue != null) {
      setValue(newValue);
      if (props.onChange) {
        props.onChange(event, newValue);
      }
    }
  };

  return (
    <HigherContrastToggleButtonGroup
      color="secondary"
      value={value}
      onChange={handleChange}
      exclusive
      size="small"
      aria-label={translate("viewAs")}
    >
      <ToggleButton value="listView" sx={{ pr: "12px", pl: "12px" }}>
        <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
          {value === "listView" ? <CheckIcon /> : <ListIcon />}
          {translate("views_list")}
        </Stack>
      </ToggleButton>
      <ToggleButton value="flowView" sx={{ pr: "12px", pl: "12px" }}>
        <Stack direction="row" spacing={{ xs: 1 }} useFlexGap>
          {value === "flowView" ? <CheckIcon /> : <ViewArrayIcon />}
          {translate("views_flow")}
        </Stack>
      </ToggleButton>
    </HigherContrastToggleButtonGroup>
  );
};
